import CompanyContactList from '@/components/CompanyContact/CompanyContactList'
import CompanyContactForm from '@/components/CompanyContact/CompanyContactForm'
import CompanyContactDetail from '@/components/CompanyContact/CompanyContactDetail'

let CompanyContactRouter = [{
  path: '/company_contact',
  name: 'CompanyContactList',
  component: CompanyContactList,
  meta: {
    title: 'Contacts entreprise',
    requiresAuth: true,
    authorizations: ['company-contact_index', 'desktop_access']
  }
}, {
  path: '/company_contact/new',
  name: 'CompanyContactNew',
  component: CompanyContactForm,
  meta: {
    title: 'Nouveau contact entreprise',
    requiresAuth: true,
    authorizations: ['company-contact_new', 'desktop_access']
  }
}, {
  path: '/company_contact/:id/edit',
  name: 'CompanyContactEdit',
  component: CompanyContactForm,
  meta: {
    title: 'Modifier un contact entreprise',
    requiresAuth: true,
    authorizations: ['company-contact_edit', 'desktop_access']
  }
}, {
  path: '/company_contact/:id',
  name: 'CompanyContactDetail',
  component: CompanyContactDetail,
  meta: {
    title: 'Fiche contact entreprise',
    requiresAuth: true,
    authorizations: ['company-contact_show', 'desktop_access']
  }
}]

export default CompanyContactRouter



// WEBPACK FOOTER //
// ./src/components/CompanyContact/router.js